import { initialSoundData } from '../data/soundData.js'

function getSoundDataStraight(numberOfBars, soundFile) {
  const data =
    soundFile && soundFile.isLoaded()
      ? soundFile.getPeaks(numberOfBars)
      : initialSoundData.slice(0, numberOfBars)

  // Used to check whether the array only contains zero values, which means we have a problem
  const errorTest = data.reduce((a, b) => a + b)
  if (errorTest === 0) {
    throw 'Error in soundFile.getPeaks(): Array only contains zeros'
  }
  return data
}

export function getSoundData(soundFile) {
  return {
    straight: {
      thick: getSoundDataStraight(250, soundFile),
      thin: getSoundDataStraight(3000, soundFile),
    },
    duration: soundFile.duration(),
  }
}
